// extracted by mini-css-extract-plugin
module.exports = {"reset":"index-module__reset___25_M7"};